import { Center, Flex } from '@chakra-ui/react';
import { MessageSendIcon, Tooltip } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface SendButtonProps {
  active: boolean;
  isEditing?: boolean;
  onClick?: () => void;
}

export function SendButton({ active, isEditing, onClick }: SendButtonProps) {
  const { t } = useTranslation();
  const preventDefault = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <Tooltip
      content={t('chat.tooltipSendButton')}
      chakraPortal={false}
      openDelay={0}
      closeDelay={0}
      showArrow={true}
    >
      <Center
        className="SendButton"
        h="1.85em"
        w="1.85em"
        ml="1"
        cursor="pointer"
        borderRadius="sm"
        // color={active ? 'colorPalette.solid' : 'fg.muted'}
        color={active ? 'brand.100' : 'fg.muted'}
        _hover={{ bg: 'bg.muted' }}
        transition="all 0.2s"
        onMouseDown={preventDefault}
        onClick={(e) => {
          preventDefault(e);
          if (!active) {
            return;
          }
          onClick?.();
        }}
      >
        <Center>
          {isEditing ? (
            <Flex
              alignItems="center"
              justifyContent="center"
              w="1.85em"
              minW="1.85em"
              h="1.85em"
              bg={active ? 'brand.100' : 'fg.muted'}
              borderRadius="sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="9"
                viewBox="0 0 13 9"
                fill="none"
              >
                <path
                  d="M0.700195 2.96662L5.23353 7.49995L12.0335 0.699951"
                  stroke="white"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Flex>
          ) : (
            <MessageSendIcon />
          )}
        </Center>
      </Center>
    </Tooltip>
  );
}
